import { PaymentSuccess } from '@/components/PaymentSuccess';

export const SuccessPage = () => {
  return <PaymentSuccess />;
}; 